import { GET_BLOG_PAGE_THEME } from './types';

export const GetBlogPageThemeAction = (blogTheme) => dispatch => {
    dispatch({
        type: GET_BLOG_PAGE_THEME,
        blogTheme: blogTheme,
    })
}